/**
 * @(#)2019/9/17.
 * String，接管表单变化
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import { set } from "lodash";
import Basics from "../Basics";
import String from "./baseString";
import { cloneDeep, get, merge } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";

/*
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param valueSplit {string} 可以将字符串切割为数组填充到表单，当value是一个数组时，在string中展示则为数组元素join valueSplit
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */
export let defaultProps = () => {
  return {
    inputParam: {},
    children: "", //子节点
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
    valueSplit: null,
    getFieldDecoratorParam: {
      valuePropName: "value",
      validateTrigger: "onChange",
      trigger: "onChange",
    },
    rules: {},
  };
};

@Connection(defaultProps)
export default class extends YxComponent {
  constructor(props, content) {
    super(props, content);
    this.divClass = "yx_input_popup";
  }

  getValueFromEvent = (value) => {
    const valueSplit = get(this.props, "valueSplit", null);
    if (value == null || value == "" || valueSplit == null) {
      return value;
    } else {
      return value.split(valueSplit);
    }
  };

  productionHtml = (props) => {
    let classParam = {
      yx_yxInput_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxInput_size_: "styleParam.size",
    };
    props.inputParam.className = this.styleParamClassName(props, classParam);
    //TODO bug太多暂时屏蔽
    // set(props, 'getFieldDecoratorParam.getValueFromEvent', this.getValueFromEvent)
    set(props, "children", get(props, "children", <String />));
    let html = Basics.html(props);
    return html;
  };

  render() {
    const props = { ...this.props };
    const Html = this.productionHtml(props);
    return Html;
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/String/YxString.js